import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class ProposalAnalyticModel {
  numNominated: number = 0
  numInterested: number = 0
  numNotInterested: number = 0
  proposalValue: number = 0

  constructor(
    data: {
      numNominated: number
      numInterested: number
      numNotInterested: number
      proposalValue: number
    } | null = null,
  ) {
    if (data) {
      this.numNominated = data.numNominated
      this.numInterested = data.numInterested
      this.numNotInterested = data.numNotInterested
      this.proposalValue = data.proposalValue
    }
  }
}
